<template>
  <div class="mb-4">
    <div class="liderki-boxes mb-3">
      <div class="liderki-boxes__box kreatywna-druzynowa">
        <div class="liderki-boxes__box-image">
          <img :src="require('@/assets/images/pic-s1-kreatywna-druzynowa.png')"
               alt="Segment image"
          />
          <h4 class="liderki-boxes__box-title mt-3">Kreatywna<br/>drużynowa</h4>
        </div>
      </div>

      <div class="liderki-boxes__box kreatywna-druzynowa">
        <div class="liderki-boxes__box-image">
          <img :src="require('@/assets/images/pic-s2-niezrownana-zwyciezczyni.png')"
               alt="Segment image"
          />
          <h4 class="liderki-boxes__box-title mt-3">Niezrównana<br/>zwyciężczyni</h4>
        </div>
      </div>

      <div class="liderki-boxes__box kreatywna-druzynowa">
        <div class="liderki-boxes__box-image">
          <img :src="require('@/assets/images/pic-s3-kreatorka-rozwiazan.png')"
               alt="Segment image"
          />
          <h4 class="liderki-boxes__box-title mt-3">Kreatorka<br/>rozwiązań</h4>
        </div>
      </div>

      <div class="liderki-boxes__box kreatywna-druzynowa">
        <div class="liderki-boxes__box-image">
          <img :src="require('@/assets/images/pic-s4-kanapowa-menadzerka.png')"
               alt="Segment image"
          />
          <h4 class="liderki-boxes__box-title mt-3">Kanapowa<br/>menadżerka</h4>
        </div>
      </div>

      <div class="liderki-boxes__box kreatywna-druzynowa">
        <div class="liderki-boxes__box-image">
          <img :src="require('@/assets/images/pic-s5-realizujaca-marzenia.png')"
               alt="Segment image"
          />
          <h4 class="liderki-boxes__box-title mt-3">Realizująca<br/>marzenia</h4>
        </div>
      </div>
    </div>

<!--    <button class="btn btn-secondary" @click="$emit('nextStartPage')">-->
<!--      Dalej-->
<!--    </button>-->
  </div>
</template>

<script>
export default {
  name: 'Start1',
  props: ['quiz', 'numStartPage'],
};
</script>
